import { TabMenuItem } from './../../core/models/menu/tab-menu-item';
import { AccountService } from './../../core/services/api/account.service';
import { MenuService } from './../../core/services/menu.service';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BlockUiService } from './../../shared/services/blockUi/block-ui.service';
import { PopupService } from './../../shared/services/popup/popup.service';
import { StorageService } from '../../core/services/storage.service';
import { ErrorService } from '../../core/services/error.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {
  selectedTab: string[] = ['/profile', 'settings'];
  tabs: TabMenuItem[] = [];

  constructor(
    private menuService: MenuService,
    private accountService: AccountService,
    private router: Router,
    private blockUiService: BlockUiService,
    private popupService: PopupService,
    public storageService: StorageService,
    private errorService: ErrorService,
  ) {}

  ngOnInit() {
    this.tabs = this.menuService.menu.settingsMenu;
    this.selectTab(this.router.url);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.selectTab(this.router.url);
      }
    });
  }

  selectTab(url: string) {
    let currentUrls = url.split('/');
    let lastUrl = this.tabs.find((tab) => tab.route?.includes(currentUrls[currentUrls.length - 1]));

    if (lastUrl) this.selectedTab = lastUrl.route;
  }

  changeTab(route: string[]) {
    this.selectedTab = route;
  }
}
